import $ from 'jquery';

export default class GtmMobileUserFeeds {
  static init(){
    this.bindCommentButtonClick();
  }

  static inViewPort(element) {
    if (!element || (element.nodeType !== 1)) { return false; }
    var rect = element.getBoundingClientRect();
    var height = document.documentElement.clientHeight;

    return (!!rect && rect.bottom >= 0 && rect.top <= height);
  }

  static bindCommentButtonClick() {
    $(".feeds-action__button-comment").click(function() {
      GtmMobileUserFeeds.pushWithVideo('click', this.getAttribute('data-video-id'), 'following', 'comment');
    });
  }

  static bindShareButtonClick(type) {
    $(".share.share--"+type).click(function() {
      GtmMobileUserFeeds.pushWithType('click', 'vod.'+this.getAttribute('data-video-id'), 'share', 'following/'+type);
    });
  }

  static pushWithVideo(event,videoId,featureName,featureLocation) {
    window.dataLayer.push({
      event: event,
      video_id: videoId,
      feature_name: featureName,
      feature_location: featureLocation,
    });
  }

  static pushWithType(event,videoId,featureName,featureLocation) {
    window.dataLayer.push({
      event: event,
      feature_name: featureName,
      feature_location: featureLocation,
      feature_type: videoId
    });
  }
}
